/**
 * ผล Recommend จาก REPORT_RECOMMEND_API GET /report/:id
 * รองรับทั้ง body แบบ flat และ { is_success, data: { ... } }
 */
export interface ReportRecommendModel {
  feedback_transcript_logs: FeedbackTranscriptLog[];
  overall_advice_transcript: string;
  /** คะแนนประเมินโอกาสได้งาน 0–100 (ถ้า API ส่งมา) */
  hiring_score?: number | null;
}

export interface FeedbackTranscriptLog {
  feedback: string;
  question: FeedbackQuestionModel;
  question_id: string;
  /**
   * ข้อความคำตอบของผู้สมัครในข้อนี้ (transcript / คำตอบจริง)
   * API อาจส่งเป็น answer_text, answer, candidate_answer
   */
  answer_text?: string;
}

export interface FeedbackQuestionModel {
  en: string;
  th: string;
}

/** ดึง payload จริงจาก response และ map field คำตอบแต่ละข้อ */
export function normalizeReportRecommend(raw: unknown): ReportRecommendModel {
  const r = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  const hasTopLevelAdvice = r.overall_advice_transcript != null || r.feedback_transcript_logs != null;
  const inner =
    !hasTopLevelAdvice &&
    r.data != null &&
    typeof r.data === "object" &&
    (r.is_success === true || r.is_success === undefined)
      ? (r.data as Record<string, unknown>)
      : r;

  const logsRaw = Array.isArray(inner.feedback_transcript_logs) ? inner.feedback_transcript_logs : [];
  const feedback_transcript_logs: FeedbackTranscriptLog[] = logsRaw.map((item, idx) => {
    const log = item && typeof item === "object" ? (item as Record<string, unknown>) : {};
    const q =
      log.question && typeof log.question === "object"
        ? (log.question as Record<string, unknown>)
        : {};
    const answerRaw =
      log.answer_text ??
      log.answer ??
      log.candidate_answer ??
      log.transcript_answer ??
      "";
    const answerStr = String(answerRaw).trim();

    return {
      question_id:
        typeof log.question_id === "string" ? log.question_id : String(log.question_id ?? `q-${idx}`),
      question: {
        th: q.th != null ? String(q.th) : "",
        en: q.en != null ? String(q.en) : "",
      },
      feedback: log.feedback != null ? String(log.feedback) : "",
      ...(answerStr ? { answer_text: answerStr } : {}),
    };
  });

  let hiring_score: number | null = null;
  const hs = inner.hiring_score;
  if (typeof hs === "number" && Number.isFinite(hs)) {
    hiring_score = Math.min(100, Math.max(0, hs));
  } else if (hs != null) {
    const n = Number(hs);
    if (Number.isFinite(n)) hiring_score = Math.min(100, Math.max(0, n));
  }

  return {
    overall_advice_transcript:
      inner.overall_advice_transcript != null ? String(inner.overall_advice_transcript) : "",
    feedback_transcript_logs,
    hiring_score: Number.isFinite(hiring_score as number) ? hiring_score : null,
  };
}
